import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'antera-lib-kanban-search-saved',
  templateUrl: './kanban-search-saved.component.html',
  styleUrls: ['./kanban-search-saved.component.scss']
})
export class KanbanSearchSavedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
